import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

export const initSentry = () =>
  Sentry.init({
    dsn: process.env.SENTRY_FRONTEND_DSN,
    integrations: [new BrowserTracing()],
    tracesSampleRate: process.env.ENVIRONMENT === 'production' ? 1.0 : 0.0,
    environment: process.env.ENVIRONMENT,
  });
